import store from "@/store";

export function is(role) {
  const loggedUser = store.getters.loggedUser;
  if (!loggedUser) return false;

  const roles = Array.isArray(role) ? role : role.split(",");

  return roles.some((role) => loggedUser.roles.includes(role));
}

export function can(permission) {
  const loggedUser = store.getters.loggedUser;
  if (!loggedUser) return false;

  // Implicitly grant "super-admin" role all permissions
  if (loggedUser.roles.includes("super-admin")) return true;

  const permissions = Array.isArray(permission)
    ? permission
    : permission.split(",");

  return permissions.some((permission) =>
    loggedUser.permissions.includes(permission)
  );
}
